import { SignatureRow } from 'components/tables/data/signature/types';
import P3Regular from 'components/typography/P3Regular';

/**
 * Column for the KEP UUID (displays first 8 characters).
 */
export default function KepMessageUuidColumn({ data }: { data: SignatureRow }) {
  return <P3Regular color="gray.8">{data.kepMessageUuid.substring(0, 8)}</P3Regular>;
}
